/** Geotab returns built-in zone types as bare id strings (`"ZoneTypeCustomerId"`) and others as `{ id }`. */
export function zoneTypeId(type: unknown): string | undefined {
  if (typeof type === "string") return type;
  if (type && typeof type === "object" && typeof (type as { id?: unknown }).id === "string") {
    return (type as { id: string }).id;
  }
  return undefined;
}
